import React, { useEffect, useState } from "react";
import BlocksPanel from "./BlocksPanel";
import StylesPanel from "./StylesPanel";
import LayersPanel from "./LayersPanel";
import "./panels.scss";

// Sidebar com 3 abas (Conteúdo / Estilos / Camadas) + toggle de recolher.
// Recolhida = barra estreita com só os ícones. Ao clicar num ícone recolhido,
// expande de volta na aba correspondente. Preferência persiste em localStorage.

const TABS = [
  { key: "content", label: "Conteúdo", icon: "fa fa-puzzle-piece" },
  { key: "styles", label: "Estilos", icon: "fa fa-paint-brush" },
  { key: "layers", label: "Camadas", icon: "fa fa-sitemap" },
];

const STORAGE_KEY = "editor-v2-sidebar-collapsed";

const SidebarTabs = ({ onCollapseChange }) => {
  const [activeTab, setActiveTab] = useState("content");
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    window.openPanel = (key) => {
      if (TABS.some((t) => t.key === key)) {
        setActiveTab(key);
        // Se o usuário disparou pelo GrapesJS (drop de bloco/seleção), garante
        // que a sidebar esteja visível para ele ver o painel de estilos.
        if (collapsed) {
          setCollapsed(false);
          try {
            localStorage.setItem(STORAGE_KEY, "0");
          } catch {}
        }
      }
    };
    return () => {
      if (window.openPanel) delete window.openPanel;
    };
  }, [collapsed]);

  useEffect(() => {
    if (typeof onCollapseChange === "function") onCollapseChange(collapsed);
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch {}
  }, [collapsed, onCollapseChange]);

  const toggleCollapsed = () => setCollapsed((v) => !v);

  const onIconClick = (key) => {
    setActiveTab(key);
    if (collapsed) setCollapsed(false);
  };

  return (
    <div className={`editor-v2-sidebar ${collapsed ? "is-collapsed" : ""}`}>
      <button
        type="button"
        className="v2-collapse-btn"
        onClick={toggleCollapsed}
        title={collapsed ? "Expandir painel" : "Recolher painel"}
        aria-label={collapsed ? "Expandir painel" : "Recolher painel"}
      >
        <i className={`fa ${collapsed ? "fa-angle-right" : "fa-angle-left"}`} />
      </button>

      {/* Rail vertical (visível apenas no estado recolhido, via CSS). */}
      <div className="v2-tabs-rail" role="tablist" aria-orientation="vertical">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`v2-rail-btn ${activeTab === t.key ? "active" : ""}`}
            onClick={() => onIconClick(t.key)}
            title={t.label}
            aria-label={t.label}
          >
            <i className={t.icon} />
          </button>
        ))}
      </div>

      {/* Tabs horizontais + conteúdo dos painéis. Ficam sempre montados
          (para os containers #blocks / #style-manager-container / etc.
          continuarem existindo para o GrapesJS). O CSS oculta quando
          `.is-collapsed` está ativo. */}
      <div className="v2-tabs-and-panes">
        <div className="v2-tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`v2-tab ${activeTab === t.key ? "active" : ""}`}
              onClick={() => setActiveTab(t.key)}
              role="tab"
              aria-selected={activeTab === t.key}
            >
              <i className={t.icon} style={{ marginRight: 6 }} />
              {t.label}
            </button>
          ))}
        </div>
        <BlocksPanel active={activeTab === "content"} />
        <StylesPanel active={activeTab === "styles"} />
        <LayersPanel active={activeTab === "layers"} />
      </div>
    </div>
  );
};

export default SidebarTabs;
